export const validation = {
  titleMaxChar: 60,
  paragraphMaxChar: 200,
  title: { required: true },
  buttons: {
    min: 0,
    max: 2
  }
}

export const buttonInitialState = [
  {
    buttonText: 'GET STARTED',
    buttonUrl: 'http://builder.renderforestsites.com',
    type: 'primary'
  },
  {
    buttonText: 'LEARN MORE',
    buttonUrl: 'http://builder.renderforestsites.com',
    type: 'primary'
  }
]
